<template>
  <div class="panel">
    <h2>Change your password</h2>
    <form @submit.prevent="submit">
      <div class="form-group" :class="formClass('current_password')">
        <label for="current_password">Current Password</label>
        <input
          id="current_password"
          v-model="currentPassword"
          name="current_password"
          autocomplete="password"
          type="password"
          class="form-control"
          required
        >
        <span v-for="error in errors['current_password']" v-if="errors['current_password']" class="help-block">{{ error }}<br></span>
      </div>

      <div class="form-group" :class="formClass('password')">
        <label for="password">New Password</label>
        <vue-password
          ref="password"
          v-model="password"
          name="new_password"
          autocomplete="off"
          placeholder="Password"
          required
          @input="updateScore"
        />
        <span v-for="error in errors['password']" v-if="errors['password']" class="help-block">{{ error }}<br></span>
        <span v-if="feedback" class="help-block" v-text="feedback" />
      </div>

      <div class="form-group">
        <label for="password_confirmation">Confirm New Password</label>
        <input
          id="password_confirmation"
          v-model="passwordConfirmation"
          name="password_confirmation"
          type="password"
          class="form-control"
          required
        >
      </div>

      <div class="form-buttons">
        <input
          type="submit"
          value="Change Password"
          class="btn btn--primary"
          :disabled="! isValid"
        >
        <a href="/account/users" class="btn ">Cancel</a>
      </div>
    </form>
  </div>
</template>

<script>
import { axios } from '@qlik-trial/automations-ui'
import { MessageLevel } from '@qlik-trial/automations-ui'

export default {
  components: { VuePassword: () => import(/* webpackChunkName: "vue-password" */'./VuePassword') },

  data() {
    return {
      currentPassword: null,
      password: null,
      passwordConfirmation: null,
      errors: {},
      cancel: null,
      feedback: null,
    }
  },

  computed: {
    user() {
      return this.$store.getters.getUser
    },

    isValid() {
      return this.password && this.password.length
          && this.passwordConfirmation && this.passwordConfirmation.length
          && !this.feedback
    },
  },

  methods: {
    submit() {
      this.errors = {}

      axios.put('/account/users/' + this.user.id + '/password', {
        current_password: this.currentPassword,
        password: this.password,
        password_confirmation: this.passwordConfirmation,
      }).then(() => {
        this.errors = {}
        this.$store.dispatch('flash', {
          message: 'Password successfully changed',
          level: MessageLevel.SUCCESS,
        })
      }).catch(errors => {
        this.errors = errors.response.data
      })
    },

    formClass(name) {
      if (name === 'password' && this.feedback) {
        return 'has-error'
      }

      if (this.errors[name]) {
        return 'has-error'
      }
    },

    updateScore() {
      if (this.cancel) {
        this.cancel()
      }

      this.errors = []

      this.$nextTick(() => {
        this.feedback = this.password.length
          ? this.$refs && this.$refs.password && this.$refs.password.feedback
          : null
      })
    },
  },
}
</script>
